<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow relative ms-3 me-3 pt-3">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Stripe Coupon</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'stripeCouponId' || editMode" :for="field.name">{{ field.label }}:</label>
              <select v-if="field.name === 'couponId'" v-model="editedConfig[field.name]" :id="field.name" class="form-select" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }">
                <option v-for="coupon in CouponsList" :value="coupon.couponId" :key="coupon.couponId">{{ coupon.couponCode }} - {{coupon.couponId}}</option>
              </select>
              <select v-if="field.name === 'stripeConfigurationId'" v-model="editedConfig[field.name]" :id="field.name" class="form-select" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }">
                <option v-for="stripeConfig in StripeConfigList" :value="stripeConfig.stripeConfigurationId" :key="stripeConfig.stripeConfigurationId">{{ stripeConfig.stripeName }} - {{stripeConfig.stripeConfigurationId}}</option>
              </select>
              <input v-if="((field.name !== 'stripeCouponId') || (field.name === 'stripeCouponId' && editMode)) && (field.name !== 'couponId') && (field.name !== 'stripeConfigurationId')"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="(field.name === 'stripeCouponId') && editMode">
            </div>
            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Stripe Coupon' }}</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {StripeCoupon} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'StripeCouponEdit',
  components: {
    Header,
  },
  data () {
    return {
      StripeConfigList: [],
      StripeCouponList: [],
      CouponsList: [],
      editedConfig: {
        stripeCouponId : this.$route.params.stripeCouponId,
        stripeConfigurationId : this.$route.params.stripeConfigurationId ,
        stripeCouponCode : this.$route.params.stripeCouponCode,
        couponId : this.$route.params.couponId
      },
      editMode: false,
      fields: [
        { name: "stripeCouponId", label: "stripeCouponId" },
        { name: "stripeConfigurationId", label: "stripeConfigurationId" },
        { name: "stripeCouponCode", label: "stripeCouponCode" },
        { name: "couponId", label: "couponId" },
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.stripeCouponId) {
      this.editMode = true;
    }
    this.doLoadCoupons()
  },
  methods: {
    saveChanges() {
      const dataToSave = new StripeCoupon(
          this.editedConfig.stripeCouponId ,
          this.editedConfig.stripeConfigurationId,
          this.editedConfig.stripeCouponCode ,
          this.editedConfig.couponId
      );

      if (this.editMode) {
        AdminService.updateStripeCoupon(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'StripeCoupons' });
        })
            .catch((error) => {
              if (error.response && error.response.data && error.response.data.message) {
                alert(error.response.data.message);
              }
            });
      } else {
        AdminService.insertStripeCoupon(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'StripeCoupons' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    },
    doLoadCoupons() {
      AdminService.getCouponsList().then((data) => {
        this.CouponsList = data;
        this.doLoadStripeConfigs();
      }).catch((error) => {
        this.error = error.message
      });
    },
    doLoadStripeConfigs() {
      AdminService.getStripeConfigurationList().then((data) => {
        this.StripeConfigList = data;
      }).catch((error) => {
        this.error = error.message
      });
    }
  }
})
</script>
<style src="../../assets/style.css">
</style>
